const { api } = require("@services/api.js");

export const postCpAvailability = ({ response }) =>
  api.post(`/cpdb/urgent-modals/action?response=${response}`);
